import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaSolicitacoesDeHonraComponent } from "./aba-solicitacoes-honra.component";


@NgModule({
    declarations:[
        AbaSolicitacoesDeHonraComponent
    ],
    imports:[
        SharedModule
    ],
    exports:[
        AbaSolicitacoesDeHonraComponent,
    ]
})
export class AbaSolicitacoesDeHonraModule {}